import React from "react";
import {useParams} from "react-router-dom";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import Container from "connectui/component/layout/Container";
import BookingInfoDrawer from "components/Panels/Booking/BookingInfoDrawer";
import Text from "connectui/component/display/Text";
import FlexContainer from "connectui/component/layout/FlexContainer";
import GuestDetailsPanel from "./GuestDetailsPanel";
import {useFeatureFlags} from "utilities/featureUtil";

const useStyles = (theme) =>
  buildStyles({
    container: {
      width: "100%",
      height: "100%",
      overflow: "auto",
      "&::-webkit-scrollbar": {width: "0!important"},
    },
  });

/**
 * @note ONCE FLAG IS RELEASED, THIS SHOULD BE MERGED WITH GUESTDETAILSPANEL.JSX
 *
 * @TODO MERGE THIS COMPONENT WITH GUESTDETAILSPANEL.JSX
 * */
const GuestDetailsPanelWrapper = ({}) => {
  const {inboxPanels} = useFeatureFlags();
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const {guest_id} = useParams();

  return !guest_id ? (
    <FlexContainer
      className={classes.container}
      alignItems="center"
      justifyContent="center"
    >
      <Text variant="textLG" color="gray400">
        {"Select a guest to see guest details"}
      </Text>
    </FlexContainer>
  ) : inboxPanels ? (
    <Container className={classes.container}>
      <GuestDetailsPanel />
    </Container>
  ) : (
    <BookingInfoDrawer hideRedirectIcon />
  );
};

export default GuestDetailsPanelWrapper;
